
import React from 'react';
import { LoaderCircle, Info } from 'lucide-react'; // Updated import: LoaderCircle instead of Hourglass
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { ProcessingDetails } from '@/types/jobSearch';

interface ProcessingStateProps {
  details: ProcessingDetails;
}

export const ProcessingState: React.FC<ProcessingStateProps> = ({ details }) => {
  return (
    <Card className="w-full max-w-lg mx-auto my-8 animate-fade-in"> {/* Added animate-fade-in */}
      <CardHeader>
        <CardTitle className="flex items-center">
          <LoaderCircle className="h-6 w-6 mr-2 animate-spin text-primary" /> {/* Changed Icon to LoaderCircle */}
          Search Processing
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-muted-foreground">{details.message}</p>
        
        <div className="space-y-1 text-xs p-3 bg-secondary/50 rounded-md border">
          <p><strong>Run ID:</strong> {details.runDetails.run_id}</p>
          <p><strong>Current Status:</strong> {details.runDetails.status || 'N/A'}</p>
          {details.runDetails.started_at && (
            <p><strong>Started At:</strong> {new Date(details.runDetails.started_at).toLocaleString()}</p>
          )}
          {details.runDetails.latest_event_at && (
            <p><strong>Last Event At:</strong> {new Date(details.runDetails.latest_event_at).toLocaleString()}</p>
          )}
        </div>
        
        {/* Changed progress bar height from h-2 to h-3 */}
        <Progress value={undefined} className="w-full h-3 [&>div]:animate-pulse" indicatorClassName="bg-primary" /> 
        
        <div className="flex items-start p-3 bg-blue-50 border border-blue-200 rounded-md text-blue-700">
          <Info className="h-5 w-5 mr-2 shrink-0 mt-0.5" />
          <p className="text-xs">
            Lutra searches can take some time to gather and process results. 
            The system is currently waiting for the search to complete. 
            If results don't appear after a few minutes, you may need to try searching again or check back later.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
